/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_SpeakersInputs */

const en_metadata_merge_speakers = /** @type {(inputs: Metadata_Merge_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speakers`)
};

const fr_metadata_merge_speakers = /** @type {(inputs: Metadata_Merge_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervenants`)
};

const de_metadata_merge_speakers = /** @type {(inputs: Metadata_Merge_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprecher`)
};

const it_metadata_merge_speakers = /** @type {(inputs: Metadata_Merge_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relatori`)
};

const ru_metadata_merge_speakers = /** @type {(inputs: Metadata_Merge_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Докладчики`)
};

const es_metadata_merge_speakers = /** @type {(inputs: Metadata_Merge_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oradores`)
};

const zh_cn2_metadata_merge_speakers = /** @type {(inputs: Metadata_Merge_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`演讲者`)
};

const ja_metadata_merge_speakers = /** @type {(inputs: Metadata_Merge_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`講演者`)
};

const hi_metadata_merge_speakers = /** @type {(inputs: Metadata_Merge_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वक्ताओं`)
};

const pt_pt2_metadata_merge_speakers = /** @type {(inputs: Metadata_Merge_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palestrantes`)
};

/**
* | output |
* | --- |
* | "Speakers" |
*
* @param {Metadata_Merge_SpeakersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_speakers = /** @type {((inputs?: Metadata_Merge_SpeakersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_SpeakersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_metadata_merge_speakers(inputs)
	if (locale === "de") return de_metadata_merge_speakers(inputs)
	if (locale === "it") return it_metadata_merge_speakers(inputs)
	if (locale === "ru") return ru_metadata_merge_speakers(inputs)
	if (locale === "es") return es_metadata_merge_speakers(inputs)
	if (locale === "zh-CN") return zh_cn2_metadata_merge_speakers(inputs)
	if (locale === "ja") return ja_metadata_merge_speakers(inputs)
	if (locale === "hi") return hi_metadata_merge_speakers(inputs)
	if (locale === "pt-PT") return pt_pt2_metadata_merge_speakers(inputs)
	return en_metadata_merge_speakers(inputs)
});